// src/technology.js
var Webflow = Webflow || [];
Webflow.push(function() {
    gsap.registerPlugin(ScrollTrigger);
    let mm = gsap.matchMedia();
    mm.add("(max-width: 766px)", () => {
        console.log("Initializing Swiper on Mobile...");
        return () => {
        };
    });

    mm.add("(min-width: 767px)", () => {
        console.log("Running Desktop Animations...");

        const finalWrapper = document.querySelector('[data-name="final_failure_wrapper"]');

        function emergencySymbolPosition() {
            return gsap.timeline({
                scrollTrigger: {
                    trigger: ".emergency_wrapper",
                    start: "center center",
                    endTrigger: finalWrapper,
                    end: "center center",
                    pin: true,
                    pinSpacing: false,
                    scrub: true,
                }
            })
        }

        var primaryTL = gsap.timeline().add(emergencySymbolPosition());


        return () => {
            console.log("Destroying Swiper on Desktop...");

        };
    });
});

